export function isElementVisible(element) {
  return element.offsetWidth > 0 || element.offsetHeight > 0;
}